import { LocaleType } from '../../constants/localeConstants';
import { getBestDateMatch } from '../../parsers/dateInput/helpers/dateHelpers';
import { DateTimeResult, InkDateType } from '../../types';
import { getSupportedFormatsForLocale } from '../internal/getSupportedDateFormatsForLocale';
import { getValidLocale } from '../internal/getValidLocale';
import { extractStandardDateTimeParts } from '../internal/standardDateTime/extractStandardDateTimeParts';
import { normalizeDate } from '../normalizeDate/normalizeDate';
import { normalizeTime } from '../normalizeTime/normalizeTime';

type NormalizeDateTimeArgs = { value: InkDateType; locale?: LocaleType };
export const normalizeDateTime = ({ value, locale }: NormalizeDateTimeArgs): DateTimeResult => {
  const result = extractStandardDateTimeParts(value);
  if (result) {
    const [dateTimeParts, timeZoneSource] = result;
    return {
      dateTimeParts,
      isValidTime: true,
      isValidDateTime: true,
      isValidDate: true,
      input: value.toString(),
      timeZoneSource,
    };
  }

  const stringValue = value?.toString();
  const supportedDateFormats = getSupportedFormatsForLocale(getValidLocale(locale));
  const bestDateMatch = getBestDateMatch(stringValue, supportedDateFormats);

  let remaining = value?.toString();
  if (bestDateMatch) {
    const toRemove = bestDateMatch.match;
    const matchIndex = stringValue.indexOf(toRemove);
    if (matchIndex !== -1) {
      remaining =
        stringValue.slice(0, matchIndex) +
        ' '.repeat(toRemove.length) +
        stringValue.slice(matchIndex + toRemove.length);
    }
  }
  const isStrictMode = false;
  const { dateParts, isValidDate } = normalizeDate({ value, locale, isStrict: isStrictMode });
  const { timeParts, isValidTime } = normalizeTime({ value: remaining, locale, isStrictMode });
  const isValidDateTime = isValidTime && isValidDate;
  return {
    dateTimeParts: { ...timeParts, ...dateParts },
    isValidDateTime,
    input: value.toString(),
    isValidTime,
    isValidDate,
    hasOnlyDate: remaining.trim() === '',
    timeZoneSource: 'local',
  };
};
